import React from 'react';

function Icon () {
  return (
    <h3>Payflow Pro</h3>
  );
}

export default Icon;
